import { FooterDisclaimerItemFragment } from './fragments';
import gql from 'graphql-tag';
import { RelatedArticlesSectionFragment } from './blog-education-center';

export const VentureMarketingPageQuery = gql`
	query VentureMarketingPage {
		allVentureMarketingSitePage {
			_id
			ventureLogos {
				logosHeading
				logos {
					asset {
						url
						altText
					}
				}
				logosBackgroundColor {
					hex
				}
			}
			featuredOverline
			featuredSummaryRaw
			featuredHeading
			featuredFundCta {
				url
				linkText
				openInNewTab
			}
			featuredPanelStats {
				value
				label
			}
			caseStudyPanel {
				caseStudyBadgeLabel
				caseStudyOverline
				caseStudyHeading
				caseStudySummary
				caseStudyImage {
					asset {
						url
						altText
					}
				}
				caseStudyLink {
					url
					linkText
					openInNewTab
				}
			}
			featuredDisclaimer
			footerDisclaimers {
				...FooterDisclaimerItemFragment
			}
			toutsPanel {
				panelOverline
				panelHeading
				panelSummary
				panelTouts {
					toutHeading
					toutSummary
					toutCta {
						url
						linkText
						openInNewTab
					}
				}
			}
			investorUpdatesSection: relatedArticles {
				...RelatedArticlesSectionFragment
			}
		}
	}
	${FooterDisclaimerItemFragment}
	${RelatedArticlesSectionFragment}
`;

export const VentureMarketingPageAboutTheFundQuery = gql`
	query VentureMarketingPage {
		allVentureMarketingSitePage {
			featuredOverline
			featuredSummaryRaw
			featuredHeading
			featuredFundCta {
				url
				linkText
				openInNewTab
			}
			featuredPanelStats {
				value
				label
			}
			featuredDisclaimer
		}
	}
`;

export const VentureMarketingPageCaseStudyQuery = gql`
	query VentureMarketingPage {
		allVentureMarketingSitePage {
			caseStudyPanel {
				caseStudyBadgeLabel
				caseStudyOverline
				caseStudyHeading
				caseStudySummary
				caseStudyImage {
					asset {
						url
						altText
					}
				}
				caseStudyLink {
					url
					linkText
					openInNewTab
				}
			}
		}
	}
`;
